export const ORDERED_LIST = 'ordered_list';
export const UNORDERED_LIST = 'unordered_list';
export const LIST_ITEM = 'list_item';



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/plugins/lists/constants.js